var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3886 10.6667H20.5414V3.55556C20.5405 2.61285 20.1795 1.70903 19.5377 1.04244C18.8958 0.375846 18.0256 0.000941 17.1179 0H14.6837C14.135 0.002419 13.6052 0.209063 13.1907 0.582431C12.7761 0.9558 12.5041 1.47115 12.4241 2.03496L11.4598 9.0477L7.3778 15.4074H0V32H23.965C26.0829 31.9975 28.1134 31.1226 29.6109 29.5673C31.1085 28.012 31.9509 25.9032 31.9533 23.7037V15.4074C31.9518 14.1506 31.4704 12.9457 30.6147 12.0569C29.759 11.1682 28.5988 10.6682 27.3886 10.6667ZM6.84715 29.6296H2.28238V17.7778H6.84715V29.6296ZM29.671 23.7037C29.6692 25.2748 29.0674 26.781 27.9977 27.8919C26.928 29.0028 25.4778 29.6277 23.965 29.6296H9.12953V16.9517L13.6464 9.9153L14.6848 2.37037H17.1179C17.4205 2.37037 17.7108 2.49524 17.9248 2.7175C18.1388 2.93977 18.2591 3.24123 18.2591 3.55556V13.037H27.3886C27.9936 13.038 28.5736 13.288 29.0015 13.7323C29.4293 14.1767 29.6701 14.779 29.671 15.4074V23.7037Z",
    fill: "#E4151B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17H1.5V30.5H8C15 31 21 31.5 29 29C32.6 19.8 30.5 13.8333 29 12H19L18.5 1.5H14L12.5 10L7.5 17Z",
    fill: "#E4151B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeRedIcon);
export default __webpack_public_path__ + "static/media/like-red-icon.fab1bc461729fcd4c85336a422ec6d0e.svg";
export { ForwardRef as ReactComponent };